<template>
  <div>
    <div v-if="!startTime && !holiday">
      ー
    </div>

    <template v-else>
      <div v-if="startTime && endTime">{{ startTime }} 〜 {{ endTime }}</div>
      <div v-if="holiday">
        {{ holiday }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["startTime", "endTime", "holiday"]
}
</script>

<style>
</style>
